(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9730,6922,5764],{

/***/ 26693:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/close-white.d3f1a0ed.svg","height":17,"width":17});

/***/ }),

/***/ 55619:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/modal-close.5d34d298.svg","height":29,"width":28});

/***/ }),

/***/ 69730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ v1_NewsLetterSignUpOverlay; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./components/core/Modal/Modal.jsx + 1 modules
var Modal = __webpack_require__(78145);
// EXTERNAL MODULE: ./components/core/ReCaptcha/ReCaptcha.jsx + 1 modules
var ReCaptcha = __webpack_require__(46394);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./components/NewsLetterSignUpOverlay/v1/index.module.scss
var index_module = __webpack_require__(87628);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./components/core/Button/Button.jsx + 1 modules
var Button = __webpack_require__(7872);
;// CONCATENATED MODULE: ./components/NewsLetterSignUpOverlay/v1/SuccessMessage.jsx



const SuccessMessage = (param)=>{
    let { confirmationTitle , confirmationDescription , closeModal , promoCode , copyCtaText , copiedCtaText , isGiftCodeEnable  } = param;
    const [copySuccess, setCopySuccess] = (0,react.useState)(copyCtaText);
    const copyToClipBoard = async (copyMe)=>{
        try {
            await navigator.clipboard.writeText(copyMe);
            setCopySuccess(copiedCtaText);
        } catch (err) {
            setCopySuccess("Failed to copy!");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "news-letter-sign-up__success-modal",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "news-letter-sign-up__thanks",
                children: confirmationTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "news-letter-sign-up__success",
                children: confirmationDescription
            }),
            isGiftCodeEnable && promoCode ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "copy-code-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "copy-code-number",
                        children: promoCode
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "copy-code-button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                            role: "button",
                            label: copySuccess,
                            type: "primary",
                            onClick: ()=>copyToClipBoard(promoCode)
                        })
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                className: "success-modal-button",
                parentClass: "parent-wrap",
                label: "Continue Shopping",
                size: "small",
                type: "primary",
                flexible: true,
                role: "button",
                onClick: closeModal
            })
        ]
    });
};
/* harmony default export */ var v1_SuccessMessage = (SuccessMessage);

;// CONCATENATED MODULE: ./components/NewsLetterSignUpOverlay/v1/analytics.js

const getPageType = ()=>{
    const page = (0,helper.getPageInfo)();
    const { category: { pageType =""  }  } = page;
    return pageType;
};
const addAnalyticsForNewsletterSignupOverlay = ()=>{
    const pageType = getPageType();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "newsletter signup overlay",
        eventMsg: "n/a",
        eventName: "newsletter signup overlay",
        eventStatus: "n/a",
        eventType: "popup",
        internalLinkName: "newsletter signup",
        internalLinkPosition: "newsletter signup",
        internalLinkType: "newsletter signup overlay",
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageType, ":newsletter signup overlay")
    };
    addAnalyticsForNewsletterSignup(eventInfo, "cmp:show");
};
const addAnalyticsForNewsletterSignupBtn = function(eventStatus) {
    let eventMsg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "n/a";
    const pageType = getPageType();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "newsletter signup",
        eventMsg,
        eventName: "newsletter signup",
        eventStatus,
        eventType: "click",
        internalLinkName: "sign up",
        internalLinkPosition: "newsletter signup",
        internalLinkType: "newsletter signup overlay:submit",
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageType, ":newsletter signup overlay")
    };
    addAnalyticsForNewsletterSignup(eventInfo, "cmp:click");
};
const addAnalyticsForNewsletterSignupLinks = function() {
    let type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", url = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "n/a";
    const linkName = type === null || type === void 0 ? void 0 : type.toLowerCase();
    const pageType = getPageType();
    const eventInfo = {
        clickInternalLinks: linkName === "close" ? "true" : "false",
        eventAction: "newsletter signup:".concat(linkName),
        eventMsg: "n/a",
        eventName: "newsletter signup:".concat(linkName),
        eventStatus: "n/a",
        eventType: "navigate",
        internalLinkName: linkName,
        internalLinkPosition: "newsletter signup",
        internalLinkType: "newsletter signup overlay:".concat(linkName),
        internalLinkURL: url,
        internalLinkZoneName: "".concat(pageType, ":newsletter signup overlay")
    };
    addAnalyticsForNewsletterSignup(eventInfo, "cmp:click");
};
const getRecaptchaAnalytics = {
    addNoFooterInAttr: true,
    pageTitle: "newsletter signup",
    internalLinkPosition: "newsletter signup",
    internalLinkTypeWithType: "newsletter signup overlay",
    internalLinkZoneName: "newsletter signup overlay"
};
const addAnalyticsForNewsletterSignup = (eventInfo, event)=>{
    const page = (0,helper.getPageInfo)();
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page
    });
};


// EXTERNAL MODULE: ./components/core/Checkbox/Checkbox.jsx + 1 modules
var Checkbox = __webpack_require__(65764);
;// CONCATENATED MODULE: ./components/NewsLetterSignUpOverlay/v1/NewsLetterForm.jsx




const NewsLetterForm = (param)=>{
    let { setEmail , overlayError , onFormSubmit , ctaLabel , heritageCheckbox ={} , setHeritageCheckbox  } = param;
    (0,react.useEffect)(()=>{
        addAnalyticsForNewsletterSignupOverlay();
    }, []);
    const checkboxChangeHandler = function(e) {
        let label = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        const { target: { checked =false  } = {}  } = e;
        const modifyHeritageCheckbox = {
            ...heritageCheckbox
        };
        modifyHeritageCheckbox[label] = checked;
        setHeritageCheckbox(modifyHeritageCheckbox);
    };
    const heritageCheckboxKeys = Object.keys(heritageCheckbox) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: (e)=>e.preventDefault(),
        className: "ui form",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                onChange: (e)=>setEmail(e.target.value),
                id: "newsletter-overlay-input",
                className: "news-letter-sign-up__email-input",
                type: "text",
                placeholder: "Email Address*"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                id: "overlay-mail-error",
                className: "overlay-mail-errormsg",
                children: overlayError
            }),
            heritageCheckboxKeys.map((item)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "news-letter-sign-up__checkbox1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox["default"], {
                        value: item,
                        checked: heritageCheckbox[item],
                        onChange: (e)=>checkboxChangeHandler(e, item)
                    })
                }, item);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                className: "news-letter-sign-up__button",
                type: "button",
                onClick: onFormSubmit,
                value: ctaLabel
            })
        ]
    });
};
/* harmony default export */ var v1_NewsLetterForm = (NewsLetterForm);

// EXTERNAL MODULE: ./node_modules/react-activity-detector/lib/ActivityDetector.js
var ActivityDetector = __webpack_require__(31166);
var ActivityDetector_default = /*#__PURE__*/__webpack_require__.n(ActivityDetector);
;// CONCATENATED MODULE: ./components/NewsLetterSignUpOverlay/v1/NewsLetterSignUpOverlay.jsx















const NewsLetterSignUpOverlay = (param)=>{
    let { data , showCampaign =false , handleModalClose  } = param;
    var ref;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticContent = (data === null || data === void 0 ? void 0 : data.content) || {};
    const { exceptionalPage =[] , useTimer =0 , copyCtaText ="" , copiedCtaText ="" , promoCode ="" , usedForCampaign =false , formTitle ="" , formDescription ="" , confirmationTitle ="" , confirmationDescription ="" , ctaLabel ="" , ctaCheckboxParameters =[] , apiEventType ="" , endpointUrl ="" , bodyParameters ={}  } = staticContent;
    const i18n = {
        privacyPolicy: t("kf.associatemembership.label.privacyPolicy"),
        subjectAccessRequest: t("kf.associatemembership.label.subjectAccessRequest"),
        termsOfService: t("kf.associatemembership.label.termsOfService")
    };
    const [config, setConfig] = (0,react.useState)({});
    const [email, setEmail] = (0,react.useState)("");
    const [showModal, setShowModal] = (0,react.useState)(showCampaign);
    const [idealTime, setIdealTime] = (0,react.useState)(constants.DEFAULT_NEWELETTER_POPUP_TRIGGER_TIME);
    const [heritageCheckbox, setHeritageCheckbox] = (0,react.useState)(ctaCheckboxParameters.reduce((obj, item)=>Object.assign(obj, {
            [item.checkboxLabel]: true
        }), {}));
    const [state, setState] = (0,react.useState)({
        cookieval: true,
        overlayError: "",
        showSuccessModal: false,
        confirmModal: false,
        cookieAccepted: false,
        timeExceeded: false
    });
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((CONFIG)=>{
            setConfig({
                siteName: get_default()(CONFIG, "general.siteName", ""),
                legalPages: get_default()(CONFIG, "legalPageData.map", {})
            });
        });
        if (usedForCampaign) localStorage.removeItem("isSignedUpForNewsletter");
    }, []);
    (0,react.useEffect)(()=>{
        if (useTimer) {
            setShowModal(true);
            // on page load open the popup based on the timer
            const timer = Number((staticContent === null || staticContent === void 0 ? void 0 : staticContent.timer) || constants.DEFAULT_NEWELETTER_POPUP_TRIGGER_TIME);
            setIdealTime(timer);
        }
    }, [
        staticContent
    ]);
    (0,react.useEffect)(()=>{
        if (showCampaign) setShowModal(showCampaign);
    }, [
        showCampaign
    ]);
    const onFormSubmit = (event)=>{
        event.preventDefault();
        const getEmailval = email;
        if (getEmailval === "") {
            setState({
                ...state,
                overlayError: "Email Address*"
            });
        } else if (!/\S+@\S+\.\S+/.test(getEmailval)) {
            setEmail("");
            setState({
                ...state,
                overlayError: "Enter valid Email Address"
            });
        } else {
            getSubscriptionData();
        }
    };
    const closeModal = ()=>{
        handleNewseletterModalClose();
    };
    const getSubscriptionData = ()=>{
        if (email) {
            let params = {
                brand: config.siteName.toLowerCase()
            };
            let body = {
                keys: {
                    SubscriberKey: email
                },
                values: {
                    ...bodyParameters
                }
            };
            body.values["EmailAddress"] = email;
            body.values["Date Updated"] = new Date().toISOString();
            if (usedForCampaign) {
                const heritageCheckboxPayload = {};
                if (ctaCheckboxParameters.length) {
                    const heritageCheckboxKeys = Object.keys(heritageCheckbox).filter((item)=>heritageCheckbox[item]);
                    const heritageCheckboxes = ctaCheckboxParameters.filter((item)=>heritageCheckboxKeys.includes(item.checkboxLabel));
                    heritageCheckboxes.forEach((item)=>{
                        const heritageCheckboxKeyObj = item.checkboxParameters.reduce((obj, itemObj)=>Object.assign(obj, {
                                [itemObj.checkboxKey]: itemObj.checkboxValue
                            }), {});
                        Object.keys(heritageCheckboxKeyObj).forEach((key)=>{
                            heritageCheckboxPayload[key] = heritageCheckboxKeyObj[key];
                        });
                    });
                }
                body = {
                    email,
                    ...heritageCheckboxPayload
                };
                params = {
                    event: apiEventType
                };
            }
            const requestPayload = usedForCampaign ? body : [
                body
            ];
            api.apim.post(endpointUrl, requestPayload, {
                params
            }).then((response)=>{
                if (response && response.data) {
                    setState({
                        ...state,
                        confirmModal: true
                    });
                    if (!usedForCampaign) localStorage.setItem("isSignedUpForNewsletter", "true");
                    addAnalyticsForNewsletterSignupBtn("success");
                } else {
                    addAnalyticsForNewsletterSignupBtn("failure", email);
                    console.error("News letter subscription API: Error occured while fetching data from Get URL Property");
                }
            }, (errObj)=>{
                const { data: { message  }  } = errObj.response;
                const { data: { error  }  } = errObj.response;
                addAnalyticsForNewsletterSignupBtn("failure", email);
                setState({
                    ...state,
                    overlayError: message || error
                });
            });
        }
    };
    (0,react.useEffect)(()=>{
        if (state.cookieAccepted) {
            localStorage.setItem(constants.PRIVACY_COOKIE_CLICKED, state.cookieAccepted);
        }
    }, [
        state.cookieAccepted
    ]);
    const handleNewseletterModalClose = ()=>{
        setShowModal(false);
        setState({
            ...state,
            confirmModal: false
        });
        if (useTimer) localStorage.setItem("isSignedUpForNewsletter", "true");
        handleModalClose();
        (0,helper.preventBodyScroll)(false);
        addAnalyticsForNewsletterSignupLinks("close", "n/a");
    };
    (0,react.useEffect)(()=>{
        if (!isDataEditorMode && !isSignedUpForNewsletter && timeExceeded && isDisplay === false) {
            (0,helper.preventBodyScroll)(true);
        }
    }, [
        state.timeExceeded
    ]);
    const onIdle = ()=>{
        setState({
            ...state,
            timeExceeded: true
        });
    };
    const { confirmModal , timeExceeded , overlayError  } = state;
    const isDisplay = exceptionalPage && exceptionalPage.length && exceptionalPage.some((page)=>page.exceptionalPageName === window.location.pathname);
    const isSubscribe = !!localStorage.getItem("isSignedUpForNewsletter");
    const isSignedUpForNewsletter = isSubscribe && !confirmModal;
    const isDataEditorMode = document.body.hasAttribute("data-editor-mode");
    const isModalVisibleBasedOnTimer = !isDataEditorMode && !isSignedUpForNewsletter && timeExceeded && isDisplay === false;
    const showNewsletterModal = useTimer ? isModalVisibleBasedOnTimer : !isSignedUpForNewsletter && showModal;
    (ref = config.legalPages) === null || ref === void 0 ? void 0 : ref.privacyPolicy;
    const { legalPages: { privacyPolicy ="n/a" , subjectAccessRequest ="n/a" , termsOfService ="n/a"  } = {}  } = config;
    const { privacyPolicy: privacyPolicyText = "" , subjectAccessRequest: subjectAccessRequestText = "" , termsOfService: termsOfServiceText = ""  } = i18n;
    const handleClickOfLinks = (text, url)=>{
        window.open(url);
        addAnalyticsForNewsletterSignupLinks(text, url);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).signupModalwrapper,
        children: [
            useTimer ? /*#__PURE__*/ (0,jsx_runtime.jsx)((ActivityDetector_default()), {
                activityEvents: constants.customActivityEvents,
                enabled: !isSignedUpForNewsletter,
                timeout: idealTime * 1000,
                onIdle: onIdle,
                name: "newsletterSignupModalActivityDetector"
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "news-letter-sign-up",
                children: showNewsletterModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                    showModal: showModal,
                    onModalClose: handleNewseletterModalClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "news-letter-sign-up__newsletter-overlay",
                        children: [
                            !confirmModal && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "news-letter-sign-up__content",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "news-letter-sign-up__header",
                                        children: (0,helper.sanitizeInnerHtml)(formTitle)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "news-letter-sign-up__subcopy",
                                        children: (0,helper.sanitizeInnerHtml)(formDescription)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_NewsLetterForm, {
                                        setEmail: setEmail,
                                        overlayError: overlayError,
                                        onFormSubmit: onFormSubmit,
                                        ctaLabel: ctaLabel,
                                        heritageCheckbox: heritageCheckbox,
                                        setHeritageCheckbox: setHeritageCheckbox
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptcha/* default */.Z, {
                                        getAnalyticsData: getRecaptchaAnalytics,
                                        isPopupNeededBeforeRedirection: false
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "news-letter-sign-up__policies",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#",
                                                onClick: ()=>handleClickOfLinks(privacyPolicyText, privacyPolicy),
                                                role: "link",
                                                children: privacyPolicyText
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#",
                                                onClick: ()=>handleClickOfLinks(subjectAccessRequestText, subjectAccessRequest),
                                                children: subjectAccessRequestText
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#",
                                                onClick: ()=>handleClickOfLinks(termsOfServiceText, termsOfService),
                                                children: termsOfServiceText
                                            })
                                        ]
                                    })
                                ]
                            }),
                            confirmModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_SuccessMessage, {
                                confirmationTitle: confirmationTitle,
                                confirmationDescription: confirmationDescription,
                                closeModal: closeModal,
                                promoCode: promoCode,
                                copyCtaText: copyCtaText,
                                copiedCtaText: copiedCtaText,
                                isGiftCodeEnable: usedForCampaign
                            })
                        ]
                    })
                }) : null
            })
        ]
    });
};
/* harmony default export */ var v1_NewsLetterSignUpOverlay = (NewsLetterSignUpOverlay);


/***/ }),

/***/ 65764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Checkbox_Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/Checkbox/index.module.scss
var index_module = __webpack_require__(43090);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./public/icons/checkbox-tick.svg
/* harmony default export */ var checkbox_tick = ({"src":"/_next/static/media/checkbox-tick.3804ed83.svg","height":10,"width":12});
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
;// CONCATENATED MODULE: ./components/core/Checkbox/Checkbox.jsx







const Checkbox = (props)=>{
    const [config, setConfig] = (0,react.useState)({});
    const { textClassName ="checkbox_default" , inline =false  } = props;
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            setConfig(config === null || config === void 0 ? void 0 : config.general);
        }).catch((err)=>console.log(err));
    }, []);
    const handleCheck = (e)=>{
        e.target.checked = !props.checked;
        if (e.keyCode === 32 || e.keyCode === 13) {
            props.onChange(e);
            e.preventDefault();
        }
    };
    var _tabIndex, _role, _checkBoxAria, ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((index_module_default()).checkboxWrapper).concat(inline ? " ".concat((index_module_default()).inlineCheckbox) : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
            tabIndex: (_tabIndex = props.tabIndex) !== null && _tabIndex !== void 0 ? _tabIndex : 0,
            "aria-checked": props.checked,
            role: (_role = props.role) !== null && _role !== void 0 ? _role : "checkbox",
            "aria-label": (_checkBoxAria = props.checkBoxAria) !== null && _checkBoxAria !== void 0 ? _checkBoxAria : props.aria,
            htmlFor: props.id,
            className: classnames_default()({
                checkbox: true,
                "checkbox--swatch": props.swatch,
                "checkbox--black": props.type === "black"
            }),
            onKeyDown: handleCheck,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    "data-gbh-data-layer": props.analyticsData || null,
                    "data-gbh-data-layer-custom": props.analyticsDataCustom || null,
                    className: props.analyticsData ? "gbh-data-layer" : "",
                    type: "checkbox",
                    name: props.id,
                    id: props.id,
                    onChange: (e)=>props.onChange(e),
                    checked: props.checked,
                    disabled: props.disabled,
                    "data-testid": (ref = props === null || props === void 0 ? void 0 : props.dataTestId) !== null && ref !== void 0 ? ref : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "checkbox__border",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "checkbox__marker",
                        children: (checkbox_tick === null || checkbox_tick === void 0 ? void 0 : checkbox_tick.src) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "checkbox__marker-icon",
                            src: checkbox_tick.src,
                            alt: "checkbox-icon",
                            "aria-hidden": true
                        }) : null
                    })
                }),
                (config === null || config === void 0 ? void 0 : config.swatchUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "checkbox__swatch",
                    style: {
                        backgroundImage: 'url("'.concat(config === null || config === void 0 ? void 0 : config.swatchUrl).concat(props === null || props === void 0 ? void 0 : props.swatch, '?$PLPSwatch_Mobile50$")')
                    }
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: textClassName,
                    children: props.value
                })
            ]
        })
    });
};
/* harmony default export */ var Checkbox_Checkbox = (Checkbox);
Checkbox.protoTypes = {
    textClassName: (prop_types_default()).string,
    checked: (prop_types_default()).bool,
    id: (prop_types_default()).string,
    tabIndex: (prop_types_default()).number,
    role: (prop_types_default()).string,
    checkBoxAria: (prop_types_default()).string,
    aria: (prop_types_default()).string,
    swatch: (prop_types_default()).string,
    type: (prop_types_default()).string,
    analyticsData: (prop_types_default()).object,
    analyticsDataCustom: (prop_types_default()).object,
    disabled: (prop_types_default()).bool,
    value: (prop_types_default()).bool,
    onChange: (prop_types_default()).func
};


/***/ }),

/***/ 78145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Modal_Modal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
;// CONCATENATED MODULE: ./components/core/FindingModelNumber/v1/analyticsEventType.js
const getEventFor = (type)=>{
    if (type === null || type === void 0 ? void 0 : type.subCategory1.includes("support:contact")) {
        return "support:contact:form";
    }
    if (type === null || type === void 0 ? void 0 : type.subCategory1.includes("support:find a service part")) {
        return "support:find-a-service-part";
    }
    if (type === null || type === void 0 ? void 0 : type.subCategory1.includes("my account:product registration")) {
        return "my account:register offline kohler products:product information";
    }
    var ref;
    return (ref = type === null || type === void 0 ? void 0 : type.subCategory1) !== null && ref !== void 0 ? ref : "";
};


// EXTERNAL MODULE: ./public/icons/close-white.svg
var close_white = __webpack_require__(26693);
// EXTERNAL MODULE: ./public/icons/modal-close.svg
var modal_close = __webpack_require__(55619);
// EXTERNAL MODULE: ./components/core/Modal/Modal.module.scss
var Modal_module = __webpack_require__(43106);
var Modal_module_default = /*#__PURE__*/__webpack_require__.n(Modal_module);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./components/core/Modal/Modal.jsx









const Modal = (props)=>{
    const modalWindow = (0,react.useRef)(null);
    const [isRendered, setIsRendered] = (0,react.useState)(false);
    const [width, height] = (0,useWindowResize/* default */.Z)();
    const [style, setStyle] = (0,react.useState)({});
    const { className , children , showModal , modalTitle , labelledBy , describedBy , onModalClose , prevActiveElem , hideCloseIcon , closeButtonAnalytics , analyticsCustomData , needAnalyticsOnContentsLink , dataLayer , StickCloseButton , isWhiteCloseIcon =false , isCloseButtonClicked =()=>{}  } = props;
    const waitingTImeForModalContentToLoad = 500;
    const triggerModalClose = (e)=>{
        (0,helper.preventBodyScroll)(false);
        isCloseButtonClicked();
        onModalClose(e);
    };
    const handleKeyPress = (e)=>{
        const focusElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const focusContent = modalWindow.current.querySelectorAll(focusElements);
        const firstElem = focusContent[0];
        const lastElem = focusContent[focusContent.length - 1];
        if (e.key === "Escape") {
            triggerModalClose();
        }
        if (e.key === "Tab") {
            if (e.shiftKey && (document.activeElement === firstElem || document.activeElement === modalWindow.current)) {
                e.preventDefault();
                lastElem.focus();
            }
            if (!e.shiftKey && document.activeElement === lastElem) {
                e.preventDefault();
                firstElem.focus();
            }
        }
    };
    (0,react.useEffect)(()=>{
        if (width < 577 || lib/* isIOS */.gn && width < 992) {
            setStyle({
                style: {
                    height: height,
                    minHeight: height
                }
            });
        } else {
            setStyle({});
        }
    }, [
        width,
        height
    ]);
    (0,react.useEffect)(()=>{
        if (showModal) {
            (0,helper.removeMavenoidChat)();
            if (!isRendered) {
                setIsRendered(true);
            }
            window.addEventListener("keydown", handleKeyPress);
            window.prevActiveElement = prevActiveElem !== null && prevActiveElem !== void 0 ? prevActiveElem : document.activeElement;
            modalWindow.current.focus();
            if (needAnalyticsOnContentsLink) {
                addAnalyticsForNavigationLinks();
            }
        } else {
            (0,helper.addMavenoidChat)();
            if (!document.getElementsByClassName("show-modal-popup").length) {
                var ref;
                (ref = window.prevActiveElement) === null || ref === void 0 ? void 0 : ref.focus();
                (0,helper.setFocus)(window.keyFocusCallBack);
            }
        }
        (0,helper.preventBodyScroll)(showModal);
        return ()=>{
            window.removeEventListener("keydown", handleKeyPress);
            (0,helper.preventBodyScroll)(false);
        };
    }, [
        showModal
    ]);
    const getNavigationLinksEventInfo = function(link, linkName) {
        let clickInternalLinks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "true";
        var ref;
        const type = window.adobeDataLayer.length > 1 ? window.adobeDataLayer[1]["page"]["category"] : {};
        const eventFor = getEventFor(type);
        const internalLinkType = (type === null || type === void 0 ? void 0 : (ref = type.subCategory1) === null || ref === void 0 ? void 0 : ref.includes("my account:product registration")) ? "my account:navigation" : "".concat(eventFor, ":navigation");
        return JSON.stringify({
            clickInternalLinks,
            eventAction: "".concat(eventFor, ":modal:where do i find my product model number:").concat(linkName),
            eventMsg: "n/a",
            eventName: "".concat(eventFor, ":modal:where do i find my product model number:").concat(linkName),
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: linkName,
            internalLinkPosition: (type === null || type === void 0 ? void 0 : type.subCategoryID) || "contact us",
            internalLinkType,
            internalLinkURL: link,
            internalLinkZoneName: "".concat(eventFor, ":modal:where do i find my product model number")
        });
    };
    const addAnalyticsForNavigationLinks = ()=>{
        setTimeout(()=>{
            modalWindow.current.querySelectorAll(".description p a").forEach((link)=>{
                link.classList.add("gbh-data-layer");
                const textContent = (link === null || link === void 0 ? void 0 : link.textContent) || (link.querySelector("u") ? link.querySelector("u").textContent : "");
                const clickInternalLinks = (textContent === null || textContent === void 0 ? void 0 : textContent.toLowerCase()) === "learn more" ? "true" : "false";
                const eventInfo = getNavigationLinksEventInfo(link.getAttribute("href"), textContent === null || textContent === void 0 ? void 0 : textContent.toLowerCase(), clickInternalLinks);
                link.setAttribute("data-gbh-data-layer", eventInfo);
            });
            modalWindow.current.querySelectorAll(".description h6 a").forEach((link)=>{
                if (link.textContent === "Learn More") {
                    link.classList.add("gbh-data-layer");
                    const eventInfo = getNavigationLinksEventInfo(link.getAttribute("href"), link.textContent.toLowerCase());
                    link.setAttribute("data-gbh-data-layer", eventInfo);
                }
            });
            modalWindow.current.querySelectorAll(".modal-popup-body a").forEach((link)=>{
                if (link.textContent === "Continue") {
                    link.classList.add("gbh-data-layer");
                    link.setAttribute("data-gbh-data-layer", dataLayer);
                }
            });
        }, waitingTImeForModalContentToLoad);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Modal_module_default()).modalWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "modal-popup ".concat(showModal ? "show-modal-popup" : "", " ").concat(className ? className : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "modal-popup-content",
                role: "dialog",
                "aria-modal": true,
                tabIndex: "-1",
                "aria-labelledby": labelledBy,
                "aria-describedby": describedBy,
                ref: modalWindow,
                ...style,
                children: [
                    !hideCloseIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "close-button-holder ".concat(StickCloseButton ? "stick-close-button" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "close-button".concat(closeButtonAnalytics ? " gbh-data-layer" : ""),
                            "data-gbh-data-layer": closeButtonAnalytics,
                            "data-gbh-data-layer-custom": analyticsCustomData || null,
                            onClick: triggerModalClose,
                            tabIndex: "0",
                            role: "button",
                            "aria-label": "Click here to close ".concat(modalTitle, " modal window"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: isWhiteCloseIcon ? close_white/* default */.Z === null || close_white/* default */.Z === void 0 ? void 0 : close_white/* default.src */.Z.src : modal_close/* default */.Z === null || modal_close/* default */.Z === void 0 ? void 0 : modal_close/* default.src */.Z.src,
                                "aria-hidden": true,
                                role: "presentation",
                                alt: "close"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "modal-popup-body",
                        children: isRendered && showModal && children
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Modal_Modal = (Modal);


/***/ }),

/***/ 46394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ReCaptcha_ReCaptcha; },
  "L": function() { return /* binding */ validateRecaptcha; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
;// CONCATENATED MODULE: ./components/core/ReCaptcha/analytics.js


const getInternalLinkURLS = (url)=>{
    return (url === null || url === void 0 ? void 0 : url.startsWith("/")) || (url === null || url === void 0 ? void 0 : url.includes(window.location.hostname)) ? "true" : "false";
};
const setLinkAnalytics = function(linkUrl, type, getAnalyticsData) {
    let eventType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "navigation";
    if (!getAnalyticsData) return null;
    const { pageTitle ="n/a" , internalLinkPosition ="n/a" , addNoFooterInAttr =false  } = getAnalyticsData;
    if (typeof type !== "string") {
        var ref;
        // this is html content
        const div = document.createElement("div");
        div.innerHTML = type;
        // This contains HTML code so remove some bugs here.
        type = (ref = div.innerText || div.textContent || "") === null || ref === void 0 ? void 0 : ref.toLowerCase();
        type = type.replaceAll("\n", "");
    } else {
        type = type.toLowerCase();
    }
    const isOrderStatusPage = pageTitle === null || pageTitle === void 0 ? void 0 : pageTitle.includes(constants.ORDER_STATUS_PAGE);
    const form = !addNoFooterInAttr ? ":form" : "";
    const formFooter = !addNoFooterInAttr ? ":form:".concat(constants.FRAGMENT_TYPES.FOOTER) : "";
    const eventDetail = isOrderStatusPage ? "".concat(pageTitle, ":").concat(type) : "".concat(pageTitle).concat(formFooter, ":").concat(type);
    const eventLinkType = isOrderStatusPage ? "my account:".concat(type) : "".concat(pageTitle).concat(form, ":").concat(type);
    const prefix = linkUrl && linkUrl.indexOf("http") === -1 ? window.location.origin : "";
    const eventInfo = {
        clickInternalLinks: getInternalLinkURLS(linkUrl),
        eventAction: eventDetail || "n/a",
        eventName: eventDetail || "n/a",
        eventType,
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type || "n/a",
        internalLinkPosition: internalLinkPosition || "n/a",
        internalLinkType: eventLinkType,
        internalLinkURL: linkUrl ? prefix + linkUrl : "n/a",
        internalLinkZoneName: "".concat(pageTitle).concat(formFooter)
    };
    addAnalyticsForRecaptchLinks(eventInfo, "cmp:click");
};
const addAnalyticsForRecaptchLinks = function(eventInfo) {
    let event = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "cmp:click";
    const page = (0,helper.getPageInfo)();
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page
    });
};


// EXTERNAL MODULE: ./components/core/ReCaptcha/Recaptcha.module.scss
var Recaptcha_module = __webpack_require__(81918);
var Recaptcha_module_default = /*#__PURE__*/__webpack_require__.n(Recaptcha_module);
;// CONCATENATED MODULE: ./components/core/ReCaptcha/ReCaptcha.jsx
/* eslint-disable no-undef */ 









let promiseResolve;
let promiseReject;
const validateRecaptcha = ()=>{
    return new Promise((resolve, reject)=>{
        (0,config/* getConfig */.i)().then((CONFIG)=>{
            try {
                const { isDisableRecaptcha  } = CONFIG.general;
                if (isDisableRecaptcha) {
                    return resolve({
                        success: isDisableRecaptcha
                    });
                }
                const { captcha: { captchaSiteKeyV3 , captchaThreshold  } , general: { siteName  }  } = CONFIG;
                promiseResolve = resolve;
                promiseReject = reject;
                grecaptcha.ready(()=>{
                    grecaptcha.reset();
                    grecaptcha.execute(captchaSiteKeyV3).then(async (token)=>{
                        try {
                            const { data  } = await (0,api.aemAxiosInstance)({
                                url: "/bin/kohler/google/captchaAuth?type=V3&access_token=".concat(token, "&brandName=").concat(siteName.toLowerCase()),
                                method: "GET"
                            });
                            if (data.score < captchaThreshold) {
                                grecaptcha.reset();
                                grecaptcha.execute();
                            } else {
                                return resolve(data);
                            }
                        } catch (error) {
                            reject(error);
                        }
                    }).catch((err1)=>reject(err1));
                });
            } catch (error) {
                reject(error);
            }
        });
    });
};
const ReCaptcha = (props)=>{
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const [links, setLinks] = (0,react.useState)({});
    const [state, setState] = (0,react.useState)({});
    const [i18n, seti18n] = (0,react.useState)({});
    const dispatch = (0,es/* useDispatch */.I0)();
    const { legalPageLinks  } = (0,es/* useSelector */.v9)(genericSlice.selectGenericState);
    const getTranslations = (t)=>{
        return {
            protectedByGoogle: t("kf.associatemembership.label.protectedByGoogle"),
            privacyPolicyGoogle: t("kf.associatemembership.label.privacyPolicyGoogle"),
            privacyPolicy: t("kf.contactus.label.privacyPolicy"),
            termsOfService: t("kf.contactus.label.termsOfService"),
            and: t("kf.contactus.message.and"),
            apply: t("kf.contactus.message.apply")
        };
    };
    (0,react.useEffect)(()=>{
        seti18n(getTranslations(t));
        (0,config/* getConfig */.i)().then((config)=>{
            const { captcha: { captchaSiteKeyV2 , captchaSiteKeyV3  } , general: { siteName  }  } = config;
            setState({
                captchaSiteKeyV2,
                captchaSiteKeyV3,
                siteName
            });
        });
    }, []);
    (0,react.useEffect)(()=>{
        const { captchaSiteKeyV2 , captchaSiteKeyV3 , siteName  } = state;
        if (captchaSiteKeyV2 && captchaSiteKeyV3 && siteName) {
            loadRecaptcha();
            getLegalPages();
        }
    }, [
        state.captchaSiteKeyV2,
        state.captchaSiteKeyV3,
        state.siteName
    ]);
    (0,react.useEffect)(()=>{
        if (legalPageLinks) {
            const { googlePrivacyPolicy , googleTermsOfService  } = legalPageLinks;
            setLinks({
                googlePrivacyPolicy,
                googleTermsOfService
            });
        }
    }, [
        legalPageLinks
    ]);
    const getLegalPages = async ()=>{
        dispatch((0,genericSlice.getLegalPageLinks)());
    };
    const loadRecaptcha = ()=>{
        const { captchaSiteKeyV2 , captchaSiteKeyV3  } = state;
        const scriptExist = document.getElementById("recaptcha-key");
        if (!scriptExist) {
            const script = document.createElement("script");
            script.src = "https://www.google.com/recaptcha/api.js?render=".concat(captchaSiteKeyV3);
            script.id = "recaptcha-key";
            script.onload = function onload() {
                grecaptcha.ready(()=>{
                    grecaptcha.render("recaptcha-container", {
                        sitekey: captchaSiteKeyV2,
                        callback: (t)=>verifyToken(t)
                    });
                });
            };
            document.body.appendChild(script);
        } else {
            grecaptcha.ready(()=>{
                grecaptcha.render("recaptcha-container", {
                    sitekey: captchaSiteKeyV2,
                    callback: (t)=>verifyToken(t)
                });
            });
        }
    };
    const verifyToken = async (token)=>{
        const CONFIG = await (0,config/* getConfig */.i)();
        const { isDisableRecaptcha  } = CONFIG.general;
        if (isDisableRecaptcha) {
            promiseResolve({
                success: isDisableRecaptcha
            });
        }
        try {
            const { data  } = await (0,api.aemAxiosInstance)({
                url: "/bin/kohler/google/captchaAuth?type=V2&access_token=".concat(token, "&brandName=").concat(state.siteName.toLowerCase()),
                method: "GET"
            });
            promiseResolve(data);
        } catch (error) {
            promiseReject(err);
        }
    };
    const { getAnalyticsData ={} , isPopupNeededBeforeRedirection =true  } = props;
    const { googlePrivacyPolicy ="n/a" , googleTermsOfService ="n/a"  } = links;
    const { privacyPolicyGoogle ="" , termsOfService =""  } = i18n;
    const handleClickOfLinks = (e, text, url)=>{
        const eventType = isPopupNeededBeforeRedirection ? "navigation" : "informative";
        if (props.addReviewRegistrationEventInfo) {
            const eventReviewInfo = props.addReviewRegistrationEventInfo(text, url, "false");
            addAnalyticsForRecaptchLinks(eventReviewInfo);
        } else {
            setLinkAnalytics(url, text, getAnalyticsData, eventType);
        }
        if (isPopupNeededBeforeRedirection) (0,helper.getSiteWideModal)(e, url);
        else window.open(url);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Recaptcha_module_default()).reCatichWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "recaptcha-container",
                    className: "g-recaptcha",
                    "data-size": "invisible"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-20 mb-20 recaptcha-links",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "".concat(i18n.protectedByGoogle, " ")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "gpolicies",
                            href: "#",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            onClick: (e)=>handleClickOfLinks(e, privacyPolicyGoogle, googlePrivacyPolicy),
                            children: privacyPolicyGoogle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                " ",
                                i18n.and,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "gpolicies",
                            href: "#",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            onClick: (e)=>handleClickOfLinks(e, termsOfService, googleTermsOfService),
                            children: termsOfService
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                " ",
                                i18n.apply
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ReCaptcha_ReCaptcha = (ReCaptcha);


/***/ }),

/***/ 87628:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"signupModalwrapper":"v1_signupModalwrapper__Zuhat"};

/***/ }),

/***/ 43090:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"Checkbox_checkboxWrapper__Fv9jK","inlineCheckbox":"Checkbox_inlineCheckbox__s9vUb"};

/***/ }),

/***/ 43106:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"Modal_modalWrapper__asWMh"};

/***/ }),

/***/ 81918:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"reCatichWrapper":"Recaptcha_reCatichWrapper__pIvbo"};

/***/ }),

/***/ 31166:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

(()=>{"use strict";var e={d:(t,o)=>{for(var r in o)e.o(o,r)&&!e.o(t,r)&&Object.defineProperty(t,r,{enumerable:!0,get:o[r]})},o:(e,t)=>Object.prototype.hasOwnProperty.call(e,t),r:e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})}},t={};e.r(t),e.d(t,{default:()=>l});const o=__webpack_require__(67294),r=["click","mousemove","keydown","DOMMouseScroll","mousewheel","mousedown","touchstart","touchmove","focus"],n="React_Activity_Detector_Idle_Timer",a=()=>(new Date).getTime();let i={},c={};const l=e=>{const{activityEvents:t,timeout:l,enabled:u,onIdle:s,onActive:d,name:m}={activityEvents:r,timeout:3e5,enabled:!1,name:"default",...e},[v,f]=(0,o.useState)(!1),w=e=>{clearTimeout(i[m]),i[m]=setTimeout((()=>{const e=(e=>localStorage.getItem(n+"-"+e))(m);a()>=e&&s&&s()}),e)},y=()=>{clearTimeout(c[m]),c[m]=setTimeout((()=>f(!1)),200),d&&d()},g=({key:e,newValue:t})=>{e===n+"-"+m&&w(t-a())};return(0,o.useEffect)((()=>(u&&(t.forEach((e=>window.addEventListener(e,y))),window.addEventListener("storage",g),f(!1)),()=>{t.forEach((e=>window.removeEventListener(e,y))),window.removeEventListener("storage",g),clearTimeout(i[m]),clearTimeout(c[m])})),[u]),(0,o.useEffect)((()=>{v||(w(l),((e,t)=>{localStorage.setItem(n+"-"+t,e)})(a()+l,m)),f(!0)}),[v,l]),v};module.exports=t})();

/***/ })

}]);